import styled from "styled-components";

export const CarouselInner = styled.div`
  position: relative;
  z-index: 2;
  width: 100%;
  padding: 0 72px;
  box-sizing: border-box;

  @media (max-width: 500px) {
    padding: 0 44px;
  }
`;

export const CarouselViewport = styled.div`
  overflow: visible;
  width: 100%;

  @media (max-width: 500px) {
    overflow: hidden;
  }
`;

export const CarouselContainer = styled.div`
  display: flex;
  align-items: stretch;
`;

export const CarouselSlide = styled.div`
  height: 100%;
  box-sizing: border-box;
  padding: 0 10px;
  display: flex;
  justify-content: center;
  align-items: stretch;
  min-width: 0;
`;

const ArrowButton = styled.button`
  position: absolute;
  top: calc(50% + 28px);
  transform: translateY(-50%);
  z-index: 100;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 1px solid rgba(225, 229, 235, 0.95);
  background: rgba(255, 255, 255, 0.96);
  box-shadow:
    0 2px 8px rgba(15, 29, 41, 0.08),
    0 1px 2px rgba(15, 29, 41, 0.04);
  cursor: pointer;
  color: #f1591e;
  font-size: 28px;
  font-weight: 300;
  line-height: 1;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease,
    opacity 0.2s ease;

  &:hover:not(:disabled) {
    background: #fff;
    border-color: #f1591e;
    box-shadow: 0 6px 16px rgba(241, 89, 30, 0.2);
    transform: translateY(-50%) scale(1.04);
  }

  &:focus-visible {
    outline: 2px solid #f1591e;
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.38;
    cursor: default;
    box-shadow: none;
  }

  @media (max-width: 500px) {
    width: 40px;
    height: 40px;
    font-size: 24px;
    top: calc(50% + 22px);
  }
`;

export const PrevButton = styled(ArrowButton)`
  left: 8px;

  @media (max-width: 500px) {
    left: 0;
  }
`;

export const NextButton = styled(ArrowButton)`
  right: 8px;

  @media (max-width: 500px) {
    right: 0;
  }
`;
